module.exports = __webpack_public_path__ + "static/img/avatar.e49bbc27.png";